<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="120px"
            size="mini"
          >
          <el-form-item label="区域" prop="orgId">
              <el-select 
                v-model="searchForm.orgId" 
                clearable 
                @change="onSearch"
              >
              <el-option label="全部" value=""></el-option>
                <el-option v-for="item in officeList"
                  :key="item.value"
                  :label="item.orgName"
                  :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商名称" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="商户名称" prop="shopName">
              <el-input
                v-model="searchForm.shopName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="shopLic">
              <el-input
                v-model="searchForm.shopLic"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人名称" prop="legalName">
              <el-input
                v-model="searchForm.legalName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请状态" prop="applyStatus">
              <el-select 
                v-model="searchForm.applyStatus" 
                clearable 
                @change="onSearch"
              >
                <el-option v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银联商户号" prop="mchNo">
              <el-input
                v-model="searchForm.mchNo"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请时间">
              <q-date-picker v-model="searchForm" startFiled="applyDateStart" endFiled="applyDateEnd" :isDefault="false" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="orgId" label="区域ID" align="center" width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orgName" label="区域名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerId" label="经销商ID" align="center" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerCode" label="经销商编码" align="center" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="mchNo" label="银联商户号" align="center" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column prop="customerName" label="经销商名称" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopLic" label="统一社会信用代码" align="center" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="legalName" label="法人名称" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="marketType" label="城市级别" align="center" width="80"></el-table-column>
          <el-table-column prop="shopName" label="商户名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyStatus" label="申请状态" align="center" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="failReason" label="失败原因" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyDate" label="申请提交时间" align="center" width="160"></el-table-column>
          <el-table-column prop="successDate" label="入网成功时间" align="center" width="160"></el-table-column>
          <el-table-column label="操作" fixed="right" class-name="action-column" width="140">
            <template v-slot="scope">
              <el-button 
                type="text" 
                size="small" 
                v-permission="'activity-pc-manage-api-new$dataReport$cmpData$netInList$cancellation'"
                v-if="scope.row.applyStatus != '草稿' && scope.row.orgName"
                @click="cancellation(scope.row.customerId)"
              >
                回退
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                v-if="scope.row.applyStatus == '入网成功' && scope.row.orgId"
                @click="modifyBankcard(scope.row)"
              >
                修改银行卡
              </el-button>
            </template> 
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      <modify-bankcard
        :isShowModifyBankcard.sync="isShowModifyBankcard"
        :archivalApplyMainId="archivalApplyMainId"
        @modifySuccess="onSearch"
      />
    </content-panel>
  </div>
</template>

<script>
import moment from 'moment';
import tableMixin from "@/utils/tableMixin";
import modifyBankcard from './components/modify-bankcard.vue';
export default {
  name: "couponData",
  mixins: [tableMixin],
  components: { modifyBankcard },
  data() {
    return {
      searchForm: {
        orgId:'',
        customerName:'',
        applyStatus: "",
        applyDateStart: "",
        applyDateEnd: "",
        shopName: "",
        shopLic: "",
        legalName: "",
        mchNo: "",
      },
      statusList: [
        {value: "",label: "全部"},
        {value: "草稿",label: "草稿"},
        {value: "资料已提交",label: "资料已提交"},
        {value: "待签约",label: "待签约"},
        {value: "对公账户待验证或异常",label: "对公账户待验证或异常"},
        {value: "入网审核中",label: "入网审核中"},
        {value: "风控审核中",label: "风控审核中"},
        {value: "入网成功",label: "入网成功"},
        {value: "入网失败",label: "入网失败"},
        {value: "资料验证失败",label: "资料验证失败"},
        {value: "冻结账户",label: "冻结账户"}
      ],
      // 表格相关
      tableData: [],
      pageSize: 50,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      officeList: [],
      archivalApplyMainId: '',
      isShowModifyBankcard: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const { applyDateStart, applyDateEnd } = this.filterParam
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          applyDateStart: applyDateStart ? moment(applyDateStart).format("YYYYMMDD") : '',
          applyDateEnd: applyDateEnd ? moment(applyDateEnd).format("YYYYMMDD") : ''
        },
      };
      this.$api.dataReport
        .unionMchPageList(params) 
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getOrgIdList() {
      this.$api.dataReport.getOrgIdList() 
        .then((res)=> {
          if (res.success && res.data) {
            this.officeList = []
            for(let [key,value] of Object.entries(res.data)) {
              this.officeList.push({ orgId: key,orgName: value })
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.applyDateStart = ''
      this.searchForm.applyDateEnd = ''
      this.$refs.dateRef.reset()
    },
    cancellation(customerId) {
      this.$confirm('确定要回退该条数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.dataReport.backUnionMchApply(customerId).then(res => {
            if (res.success) {
              this.$message.success("回退成功");
              this.onSearch()
            }
          })
        }).catch(() => {});
     
    },
    modifyBankcard(row) {
      this.archivalApplyMainId = row.archivalApplyMainId
      this.isShowModifyBankcard = true
    },
    exportList() {
      const { applyDateStart, applyDateEnd } = this.filterParam
      let params = {
        ...this.filterParam,
        applyDateStart: applyDateStart ? moment(applyDateStart).format("YYYYMMDD") : '',
        applyDateEnd: applyDateEnd ? moment(applyDateEnd).format("YYYYMMDD") : ''
      };
      this.$api.common.doExport("unionMchPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  mounted() {
    this.init();
    this.getOrgIdList()
  },
};
</script>
<style lang="stylus" scoped>
  .btn  {
    padding: 5px;
  }

</style>
